/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICacheKey } from './ICache';

export const normalizeCacheKey = (cacheKey: ICacheKey): ICacheKey => {
    return {
        typeName: cacheKey.typeName.toUpperCase(),
        key: cacheKey.key.toUpperCase()
    };
};
